import { render } from "./ShippingDestination.vue?vue&type=template&id=5792c593&scoped=true"
import script from "./ShippingDestination.vue?vue&type=script&lang=ts"
export * from "./ShippingDestination.vue?vue&type=script&lang=ts"

import "./ShippingDestination.vue?vue&type=style&index=0&id=5792c593&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5792c593"

export default script